import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConvites } from '../context';
import { formatarPeriodo } from '@/pages/evento/utils';

export default function ConviteGlobal() {
  const navigate = useNavigate();
  const { convites, carregando, aceitar } = useConvites();
  const [fechado, setFechado] = useState(false);
  const [aceitando, setAceitando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  if (carregando || fechado || convites.length === 0) return null;

  const atual = convites[0];
  const periodo = formatarPeriodo(atual.inicio_em, atual.fim_em ?? atual.inicio_em);
  const lugar = [atual.local_nome, atual.cidade].filter(Boolean).join(', ');

  async function aoAceitar() {
    setAceitando(true);
    setErro(null);
    const msg = await aceitar(atual.evento_id);
    if (msg) {
      setErro(msg);
      setAceitando(false);
      return;
    }
    setAceitando(false);
    navigate(`/gerenciar/${atual.evento_id}`);
  }

  function aoFechar() {
    setFechado(true);
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={aoFechar} />
      <div className="relative w-full max-w-[400px] animate-modal-pop overflow-hidden rounded-lg border border-secondary-200 bg-white">
        <div className="h-[10px] w-full bg-primary-500" />
        <div className="p-6 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-600">
            <i className="ri-mail-line text-2xl" />
          </span>

          <h2 className="mt-4 text-xl font-medium text-foreground-950">Você foi convidado</h2>
          <p className="mt-1 text-sm text-secondary-500">
            {atual.convidado_por} convidou você para ajudar a administrar
          </p>

          <p className="mt-4 text-lg font-medium leading-snug text-foreground-950">
            {atual.evento}
          </p>
          <p className="mt-1 text-sm text-secondary-500">
            {periodo}
            {lugar ? ` · ${lugar}` : ''}
          </p>

          <p className="mt-4 text-sm text-secondary-500">
            Aceitando, você passa a ver os inscritos, as fichas e os relatórios deste evento.
          </p>

          {erro && (
            <p className="mt-3 rounded-md bg-danger-50 px-3 py-2 text-sm text-danger-700">
              {erro}
            </p>
          )}

          <div className="mt-6 flex items-center justify-center gap-3">
            <button
              type="button"
              onClick={aoAceitar}
              disabled={aceitando}
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {aceitando ? 'Aceitando…' : 'Aceitar'}
            </button>
            <button
              type="button"
              onClick={aoFechar}
              className="cursor-pointer whitespace-nowrap text-sm font-medium text-secondary-500 transition-colors hover:text-foreground-800"
            >
              Agora não
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}